export default __webpack_public_path__ + "static/media/share.948349d5.svg";